import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";

const name = "OrcamentosLiberados";
export default defineComponent({
  name,
  components: {
    "g-card": gCard,
    "g-form": gForm,
    "g-date-input": gDateInput,
    "g-button": gButton,
    "g-data-table": gDataTable,
  },

  props: {},

  mounted() {
    this.getEmpresa();
    this.RepresentanteId = this.$store.state.representanteSelecionadoId
    // this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.RepresentanteId = this.$store.state.representanteSelecionadoId
      // this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId
    })

    let urlParams = new URLSearchParams(window.location.search)

    if(urlParams.get('FlagDashboard') !== null){
      // this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId;
      this.buscar()
    }
  },

  updated() {},

  data() {
    return {
      gerarCartaPropostaPopup: false,
      OrcamentoSelecionadoId: "",
      colunasOrcamentosDigitacao: null,
      LinhaProdutoArray: [],
      CidadeSelecionada: {},
      dataProduto: null,
      linhaSelecionada: {},

      EmpresaSelecionada: null,

      ClienteSelecionado: null,

      OrcamentoSelecionado: null,
      OrcamentoArray: [],
      popup: false,

      redirecionarParaOrcamento: false,
      mensagemvazio: true,
      informacaoOrcamentoSelecionado: null,

      cartaPropostaId: null,

      dataClientes: [],
      EmpresaArray: [],
      produtoArray: [],
      OrcamentoProdutoArray: [],

      formSearch: {
        UnidadeId: null,
        ClienteId: undefined,
        OrcamentoProdutoId: null,
        PeriodoEmissaoInicio: null,
        PeriodoEmissaoFim: null,
        PeriodoBaixaInicio: null,
        PeriodoBaixaFim: null,
        NumeroSolicitacao: null,
      },

      Colunas: [
        //Campo dos dados , nome que aparece na página
        { field: "numeroSolicitacao", header: "N° Solicitação", width: '120px', ordena: true  },
        { field: "dataDigitacaoFormatadaText", header: "Dt. Digitação", width: '120px', ordena: true, ordenacao: 'dataDigitacao' },
        { field: "dataAlteracaoFormatada", header: "Dt. Retorno", width: '120px', ordena: true, ordenacao: 'dataAlteracaoFormatada' },
        { field: "nomeProduto", header: "Produto", width: '350px', ordena: true },
        { field: "orcamentoSituacaoEnum", header: "Status", width: '220px', ordena: true },
        // {field: 'CV', header: 'CV'},
        { field: "nomeEmpresa", header: "Empresa", width: '220px', ordena: true },
        { field: "nomeRepresentante", header: "Representante", width: '200px', ordena: true },
        { field: "nomeFantasia", header: "Cliente", width: '220px', ordena: true },
        { field: "tipoText", header: "Tipo", width: '260px', ordena: true },
        { field: "dataAlteracaoFormatada", header: "Última Atualização", width: '180px', ordena: true, ordenacao: 'dataAlteracaoFormatada' }, //RENOMEAR ISSO AQUI

      ],
      Filtro: {
        global: { value: null, matchMode: this.filtros.CONTAINS }, //permite buscar por colunas específicas
        numeroSolicitacao: { value: null, matchMode: this.filtros.CONTAINS },
        CV: { value: null, matchMode: this.filtros.CONTAINS },
        nomeFantasia: { value: null, matchMode: this.filtros.CONTAINS },
        nomeProduto: { value: null, matchMode: this.filtros.CONTAINS },
        dataDigitacaoFormatadaText: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
        dataAlteracaoFormatada: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
        tipoText: { value: null, matchMode: this.filtros.CONTAINS },
        nomeEmpresa: { value: null, matchMode: this.filtros.CONTAINS },
        nomeRepresentante: { value: null, matchMode: this.filtros.CONTAINS },
        orcamentoSituacaoEnum: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
      },

      ClienteId: null,
      EmpresaId: null,
      RepresentanteId: null,
    };
  },

  methods: {
    buscar() {
      this.formSearch.RepresentanteId = this.RepresentanteId;
      (this.mensagemvazio = false), this.$isLoading(true);
      this.axios({
        method: "post",
        data: this.formSearch,
        url: process.env.VUE_APP_WEB_API + "Orcamento/GetOrcamentoLiberado",
      }).then((response) => {
        this.OrcamentoArray = response.data.data;
        // this.EmpresaId =  response.data.data.empresaId
        // this.ClienteId = response.data.data.clienteId
        this.$isLoading(false);
      });
    },
    habilitarbotao() {},
    clear() {
      Object.keys(this.formSearch).forEach((Element) => {
        this.formSearch[Element] = null;
      });
    },
    continuarOrca(informacaoDaLinha) {
      let OrcamentoId = informacaoDaLinha.id;
      let tipoFluxoOrcamento = informacaoDaLinha.tipoFluxoOrcamento;

      switch (tipoFluxoOrcamento) {
        case 0:
          this.$router.push(`/produto-novo/${OrcamentoId}/infos-cliente`);
          break;
        case 1:
          this.$router.push(
            `/produto-repeticao/${OrcamentoId}/Informacao-Cliente-Repeticao`
          );
          break;
        case 2:
          this.$router.push(
            `/produto-repeticao-alteracao/${OrcamentoId}/info-cliente-ra`
          );
          break;
      }
    },

    redireciona() {
      this.continuarOrca(this.informacaoOrcamentoSelecionado);
    },

    abrePopup(informacaoDaLinha) {
      this.gerarCartaPropostaPopup = true;
      this.OrcamentoSelecionadoId = informacaoDaLinha.id;
      this.EmpresaId = informacaoDaLinha.empresaId;
      this.ClienteId = informacaoDaLinha.clienteId;
      this.RepresentanteId = informacaoDaLinha.representanteId;
    },

    fechaPopup() {
      this.popup = false;
    },

    getClientes(valor) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsByNome(valor, this.formSearch.UnidadeId, this.RepresentanteId)
          .requisicao.then((Response) => {
            this.dataClientes = Response.data.data;
          })
          .catch(() => {
          });
      }, 1000);
    },

    getOrcamentoProdutos(valor){

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(valor, this.$store.state.representanteSelecionadoId, this.formSearch.UnidadeId).requisicao
        .then(res => {
          this.OrcamentoProdutoArray = res.data.data;
        })
      }, 1000);
    },

    getEmpresa() {
      this.EmpresaArray = this.$store.state.EmpresaArray;
    },

    redirecionaCriarCartaProposta(informacaoDaLinha) {
      this.OrcamentoSelecionadoId = informacaoDaLinha.id;
    },

    criarCartaProposta() {
      this.axios({
        method: "post",
        url:
          process.env.VUE_APP_WEB_API +
          `CartaProposta/InsertCartaPropostaOrcamentoLiberado/${this.OrcamentoSelecionadoId}/${this.EmpresaId}/${this.ClienteId}/${this.RepresentanteId}`,
      }).then((response) => {
        this.cartaId = response.data.data;
        this.$router.push(`/gerar-carta-proposta/${this.cartaId}/pagamento`);
      });
    },
  },

  computed: {},
});
